import { render } from "./projectCase.vue?vue&type=template&id=448ab53f&scoped=true&ts=true"
import script from "./projectCase.vue?vue&type=script&lang=ts"
export * from "./projectCase.vue?vue&type=script&lang=ts"

import "./projectCase.vue?vue&type=style&index=0&id=448ab53f&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448ab53f"]])

export default __exports__